/*
 * AddClass Messages
 *
 * This contains all the text for the AddClass component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    addClass: {
        id: 'app.components.AddClass.addClass',
        defaultMessage: 'Add a {productName} class'
    },
    addClassConfirmation: {
        id: 'app.components.AddClass.addClassConfirmation',
        defaultMessage: 'has been created'
    },
    classNameLabel: {
        id: 'app.components.AddClass.classNameLabel',
        defaultMessage: 'Class Name'
    },
    yearDropdownLabel: {
        id: 'app.components.AddClass.yearDropdownLabel',
        defaultMessage: 'Years'
    },
    countryDropdownLabel: {
        id: 'app.components.AddClass.countryDropdownLabel',
        defaultMessage: 'Select a country'
    },
    courseDropdownLabel: {
        id: 'app.components.AddClass.courseDropdownLabel',
        defaultMessage: 'Select a course'
    },
    teacherDropdownLabel: {
        id: 'app.components.AddClass.teacherDropdownLabel',
        defaultMessage: 'Select a {product} teacher'
    },
    noTeacherDropdownLabel: {
        id: 'app.components.AddClass.noTeacherDropdownLabel',
        defaultMessage: 'No teachers found'
    },
    done: {
        id: 'app.components.AddClass.done',
        defaultMessage: 'Done'
    },
    schoolCourses: {
        id: 'app.components.AddClass.schoolCourses',
        defaultMessage: 'School courses'
    },
    noCourses: {
        id: 'app.components.AddClass.noCourses',
        defaultMessage: 'No courses found'
    },
    loadingCourses: {
        id: 'app.components.AddClass.loadingCourses',
        defaultMessage: 'Loading...'
    },
    mathsClass: {
        id: 'app.components.AddClass.mathsClass',
        defaultMessage: 'maths class'
    },
    className: {
        id: 'app.components.AddClass.className',
        defaultMessage: 'Class name'
    },
    teacher: {
        id: 'app.components.AddClass.teacher',
        defaultMessage: 'Teacher'
    },
    select: {
        id: 'app.components.AddClass.select',
        defaultMessage: 'select'
    },
    grade: {
        id: 'app.components.AddClass.grade',
        defaultMessage: 'Grade'
    },
    country: {
        id: 'app.components.AddClass.country',
        defaultMessage: 'Country'
    },
    skillQuests: {
        id: 'app.components.AddClass.skillQuests',
        defaultMessage: 'Skill Quests'
    },
    courses: {
        id: 'app.components.AddClass.courses',
        defaultMessage: 'Courses (Activity Mastery)'
    },
    coursesNonMaths: {
        id: 'app.components.AddClass.coursesNonMaths',
        defaultMessage: 'Courses'
    },
    selectDefaultCourse: {
        id: 'app.components.AddClass.selectDefaultCourse',
        defaultMessage: 'Select default course'
    },
    customCourses: {
        id: 'app.components.AddClass.customCourses',
        defaultMessage: 'Custom school courses'
    },
    curriculumCourses: {
        id: 'app.components.AddClass.curriculumCourses',
        defaultMessage: 'Curriculum based courses'
    },
    cancel: {
        id: 'app.components.AddClass.cancel',
        defaultMessage: 'Cancel'
    },
    add: {
        id: 'app.components.AddClass.add',
        defaultMessage: 'Add'
    },
    required: {
        id: 'app.components.AddClass.required',
        defaultMessage: 'Required selection'
    },
    none: {
        id: 'app.components.AddClass.none',
        defaultMessage: 'None'
    },
    noCoursesFound: {
        id: 'app.components.AddClass.noCoursesFound',
        defaultMessage: 'No courses found'
    },
    newCourses: {
        id: 'app.components.AddClass.newCourses',
        defaultMessage: 'New Courses'
    },
    useAdminSelection: {
        id: 'app.components.AddClass.useAdminSelection',
        defaultMessage: 'Use admin selection'
    }
});



// WEBPACK FOOTER //
// ./app/components/add-class/messages.js